import styled from "@emotion/styled";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { Grid } from "@mui/material";
import { motion } from "framer-motion";
import ImageList from "../ImageList";

import { CharityDonation } from "./CharityDonation";
import { CartButton } from './ImageComponents';

const ImageTile = styled.div`
  display: block;
  max-width: 400px;
`;

const ImageTitle = styled.h2`
  text-align: left;
  margin: 5pt 0pt;
`;

const ImageDescription = styled.p`
  margin: 5pt 0pt;
`;

const Cards = () => {
  return (
    <Grid
      container
      columnGap={10}
      rowGap={10}
      width={"100%"}
      justifyContent={"center"}
      columns={3}
    >
      {ImageList.map((element, index) => {
        return element.cards?.etsyUrl && (
          <Grid item key={`${element.id}`}>
            <motion.div
              key={element.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.3 + (0.3 * (Math.min(index, 4))) }}
            >
              <ImageTile id={element.id}>
                <img
                  src={`/images/cards/${element.id}/400.jpeg`}
                  width={"100%"}
                  alt={element.title}
                />
                <ImageTitle>{element.title}</ImageTitle>
                <ImageDescription>{element.cards.shortText}</ImageDescription>
                <CartButton variant="contained" size="small" href={element.cards?.etsyUrl} startIcon={<AddShoppingCartIcon />}>Buy on Etsy</CartButton>
                <CharityDonation />
              </ImageTile>
            </motion.div>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default Cards;
